import { useAccount } from 'modules/account/hooks/useAccount';
import { useAppSelector } from 'store/useAppSelector';

import {
  selectHasAccountStatusTransition,
  selectHasFreemiumToPremiumTransition,
} from '../store/selectors';

export const useAccountStatusTransition = () => {
  const { group, userEndpointToken } = useAccount();

  const hasAccountStatusTransition = useAppSelector(state =>
    selectHasAccountStatusTransition(state, userEndpointToken!, group),
  );

  const hasFreemiumToPremiumTransition = useAppSelector(state =>
    selectHasFreemiumToPremiumTransition(state, userEndpointToken!, group),
  );

  return { hasAccountStatusTransition, hasFreemiumToPremiumTransition };
};
